import { useMinAndMaxRoomNum } from "@/components/features/items/edit/plan/_shared/ui/components/min-and-max-people-num/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const usePlanMinAndMaxRoomNum = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { minRoomNum, maxRoomNum } = viewModel;

	return useMinAndMaxRoomNum({
		minRoomNum,
		maxRoomNum,
		onSetViewModel,
	});
};
